export enum ItemType
{
    KennisCafe,
    Trainingen
}